var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTickSquare = function SvgTickSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#696EFF",
    d: "M13.493 1.668H6.51c-3.034 0-4.842 1.808-4.842 4.842v6.975c0 3.041 1.808 4.85 4.842 4.85h6.975c3.033 0 4.841-1.809 4.841-4.842V6.51c.009-3.034-1.8-4.842-4.833-4.842Zm.492 6.417L9.26 12.81a.624.624 0 0 1-.884 0L6.018 10.45a.629.629 0 0 1 0-.883.629.629 0 0 1 .883 0l1.917 1.917L13.101 7.2a.629.629 0 0 1 .884 0 .629.629 0 0 1 0 .884"
  })));
};
export default SvgTickSquare;